
import * as React from 'react';
import styled from 'styled-components';

import { getColor} from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Event } from '@process-advisor/process-miner/api/events';
import { TimeSection } from '@process-advisor/process-miner/time/timeSection';
import { ShowColors } from '@process-advisor/process-miner/time/showColors';


const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background-color: ${getColor('white')};
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 10px;
`;

const Container = styled.div`
`;

const Grid = styled.div`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 75px 100px 75px 80px 75x 80px 75px 100px 75px 25px 75px 100px;
`;

const ActivityLabel = styled.div`
    grid-row: 1 ;
    grid-column: 1;  
`;
const ActivityValue = styled.div`
    grid-row: 1 ;
    grid-column: 2;  
`;
const MetricLabel = styled.div`
    grid-row: 1 ;
    grid-column: 3;  
`;
const MetricValue = styled.div`
    grid-row: 1 ;
    grid-column: 4;  
`;
const AggregationLabel = styled.div`
    grid-row: 1 ;
    grid-column: 5;  
`;
const AggregationValue = styled.div`
    grid-row: 1 ;
    grid-column: 6;  
`;
const FormatLabel = styled.div`
    grid-row: 1 ;
    grid-column: 7;  
`;
const FormatValue = styled.div`
    grid-row: 1 ;
    grid-column: 8;  
`;
const ShowColorsLabel = styled.div`
    grid-row: 1 ;
    grid-column: 9;  
`;
const ShowColorsValue = styled.div`
    grid-row: 1 ;
    grid-column: 10;  
`;
const ShowEndActivityLabel = styled.div`
    grid-row: 1 ;
    grid-column: 11;  
`;
const ShowEndActivityValue = styled.div`
    grid-row: 1 ;
    grid-column: 12;  
`;



let activityOptions = [{ value: '', label: '' }]

const durationFormatOptions = [
    { value: 'DD:HH:MM', label: 'DD:HH:MM' },
    { value: 'DD:HH:MM:SS', label: 'DD:HH:MM:SS' },
    { value: 'DD:HH', label: 'DD:HH' },
    { value: 'DD', label: 'DD' },
    { value: 'HH:MM', label: 'HH:MM' },
    { value: 'HH:MM:SS', label: 'HH:MM:SS' },
    { value: 'HH', label: 'HH' },
];

const aggregationOptions = [
    { value: 'avg', label: 'Average' },
    { value: 'sum', label: 'Sum' },
//    { value: 'std_dev', label: 'Std Deviation' },
];

const metricOptions = [
    { value: 'duration', label: 'Duration' },
    { value: 'count', label: 'Count' },
    { value: 'worklogs', label: 'Worklogs' },
    { value: 'time_spent', label: 'Time Spent' },
];

let endActivityOptions = [{ value: 'N/A', label: 'N/A' }]

export const TimeInActivityOptions: React.FC = () => {
    const [durationFormat, setDurationFormat] = React.useState<string>('DD:HH:MM');
    const [activityType, setActivityType] = React.useState<string>('');
    const [aggregation, setAggregation] = React.useState<string>('avg');
    const [metric, setMetric] = React.useState<string>('duration');
    const [endActivity, setEndActivity] = React.useState<string>('N/A');

    React.useEffect(() => {
        activityOptions = apiProvider.activityTypes({});
        setActivityType(activityOptions[0].label);
        apiProvider.setTimeActivityType({activity: activityOptions[0].label})
        updateActivities()
    }, []);

    function updateActivities() {
        let activityType = apiProvider.getTimeActivityType()
        let activityArray = apiProvider.getActivityArray()
        endActivityOptions = [{ value: 'N/A', label: 'N/A' }]
        for (let j = 0; j < activityArray.length; j++) {
            if (activityArray[j].activity_type === activityType ) {
                let vtp = []
                vtp['value'] = activityArray[j].activity
                vtp['label'] = activityArray[j].activity
                endActivityOptions.push(vtp)
            }
        }
    }

    const onAggregationChange = (value: string) => {
        apiProvider.setInitialAALoad({value: true})
        setAggregation(value);
        apiProvider.setTimeAggregation({aggregation: value})
        apiProvider.eventEmitter.emit(Event.updateTimeInActivity);
    };

    const onMetricChange = (value: string) => {
        apiProvider.setInitialAALoad({value: true})
        setMetric(value);
        apiProvider.setTimeMetric({metric: value})
        apiProvider.eventEmitter.emit(Event.updateTimeInActivity);
    };

    const onActivityTypeChange = (activityType: string) => {
        apiProvider.setInitialAALoad({value: true})
        setActivityType(activityType);
        apiProvider.setTimeActivityType({activity: activityType})
        apiProvider.eventEmitter.emit(Event.updateTimeInActivity);
        updateActivities()
    }

    const onDurationFormatChange = (value: string) => {
        setDurationFormat(value);
        apiProvider.setTimeDurationFormat({durationFormat: value})
        apiProvider.eventEmitter.emit(Event.updateTimeInActivity);
    };

    const onEndActivityChange = (value: string) => {
        apiProvider.setInitialAALoad({value: true})
        setEndActivity(value);
        apiProvider.setTimeEndActivity({end_activity: value})
        apiProvider.eventEmitter.emit(Event.updateTimeInActivity);
    };

    return (
        <Wrapper>
            <Grid>
                <MetricLabel>
                    <TimeSection title='Metric'/>
                </MetricLabel>
                <MetricValue>
                    <Dropdown
                        options={metricOptions}
                        onChange={onMetricChange}
                        value={metric} />                
                </MetricValue>

                    <AggregationLabel>
                        <TimeSection title='Aggregation'/>
                    </AggregationLabel>
                    <AggregationValue>
                    <Dropdown
                            options={aggregationOptions}
                            onChange={onAggregationChange}
                            value={aggregation} />
                    </AggregationValue>
                    <FormatLabel>
                        <TimeSection title='Duration Format'/>
                    </FormatLabel>
                    <FormatValue>
                        <Dropdown
                            options={durationFormatOptions}
                            onChange={onDurationFormatChange}
                            value={durationFormat} />
                    </FormatValue>
                    <ShowColorsLabel>
                        <TimeSection title='Colors'/>
                    </ShowColorsLabel>
                    <ShowColorsValue>
                        <ShowColors/>
                    </ShowColorsValue>
                    <ShowEndActivityLabel>
                        <TimeSection title='End Activity'/>
                    </ShowEndActivityLabel>
                    <ShowEndActivityValue>
                    <Dropdown
                        options={endActivityOptions}
                        onChange={onEndActivityChange}
                        value={endActivity} />     
                    </ShowEndActivityValue>
                
            </Grid>
        </Wrapper>
    );
};
